export default __webpack_public_path__ + "static/media/Bg3.396eac91.png";